// src/render/game.ts — Phaser.Game factory.
// Kept as a standalone factory so PhaserGame.tsx (React) and canvas.test.tsx (mock)
// both reference the same mount function. Plan 06's SW wiring will later inject
// the AudioContext unlock hook through this factory.

// Phaser 4's ESM build exports only named symbols — no default export.
import * as Phaser from 'phaser';

import { BootScene } from './scenes/BootScene';
import { GameScene } from './scenes/GameScene';

export function createGame(parent: HTMLElement): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.WEBGL,
    parent,
    width: parent.clientWidth,
    height: parent.clientHeight,
    backgroundColor: '#0d1f2d',
    // Phase 1 gap closure (01-05): Arcade Physics must be opted in.
    // Phaser 4's DefaultPlugins does NOT include any physics; scene.physics
    // is undefined without this block, and GameScene.create() throws on
    // this.physics.add.existing(...) (UAT Test 1 blank-screen regression).
    // Top-down game → zero gravity; debug bodies off in prod (flip true locally to tune colliders).
    physics: {
      default: 'arcade',
      arcade: {
        gravity: { x: 0, y: 0 },
        debug: false,
      },
    },
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: [BootScene, GameScene],
  });
}
